import { VersioningStatusEnum } from '@/enums/VersioningStatus';
import { CourseModule } from './CourseModule';
import { Model } from './Model';

export interface LastVersionDto {
  title: string;
  slug: string;
  status: VersioningStatusEnum;
  version: number;
}

export enum CourseActiveEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export class Course extends Model {
  name!: string;
  abbreviation!: string;
  formats!: CourseFormatEnum[];
  isActive!: boolean;
  bannerImg!: File | string | null;
  url?: string;
  studentsCount?: number;
  duration?: number | null;
  coursePathSlug?: string;
  coursePathStatus?: VersioningStatusEnum;
  lastCoursePathVersion?: number;
  moduleId!: number;
  module?: CourseModule;
  businessModels!: BusinessModelEnum[];
  modalities!: ModalityEnum[];
  hasLessonBlocks?: boolean;

  constructor(course: Course) {
    super();
    Object.assign(this, course);
    this.checkBannerImg?.();
  }

  private checkBannerImg?(): void {
    if (!this.bannerImg) {
      this.bannerImg = '/images/course-default-image.png';
    }
  }
}

export enum BusinessModelEnum {
  CNA_STANDARD = 'CNA_STANDARD',
  IN_SCHOOL = 'IN_SCHOOL',
  SELF_PACED = 'SELF_PACED',
}

export enum ModalityEnum {
  EXTENSIVE = 'EXTENSIVE',
  INTENSIVE = 'INTENSIVE',
  PLUS = 'PLUS',
}

export enum CourseFormatEnum {
  IN_PERSON = 'IN_PERSON',
  ONLINE = 'ONLINE',
  SCHOOL = 'SCHOOL',
  EXTRA_COURSE = 'EXTRA_COURSE',
  SELF_PACED = 'SELF_PACED',
}

export interface CourseStatistics {
  activeEnrollmentsCount: number;
  canceledEnrollmentsCount: number;
  reportsCount: number;
  presencesCount: number;
  previousActiveEnrollmentsCount: number;
}

export enum CourseDurationEnum {
  ONE_HOUR = '1h',
  ONE_HOUR_AND_A_HALF = '1h30m',
  TWO_HOURS = '2h',
  TWO_HOURS_AND_A_HALF = '2h30m',
  THREE_HOURS = '3h',
}

export enum CourseDurationMinuteEnum {
  ONE_HOUR = 60,
  ONE_HOUR_AND_A_HALF = 90,
  TWO_HOURS = 120,
  TWO_HOURS_AND_A_HALF = 150,
  THREE_HOURS = 180,
}

export enum FrequencyTypeEnum {
  WEEKLY = 'WEEKLY',
  TWICE_WEEK = 'TWICE_WEEK',
  EVERY_WEEKDAY = 'EVERY_WEEKDAY',
}

export type ContentCreatorCourseDTO = {
  contentCreatorId: number;
  courseId: number;
};

export type ContentCreatorCourse = {
  id: number;
  contentCreatorId: number;
  course: Course;
};
